import { render, staticRenderFns } from "./EditCardDetailsFormNew.vue?vue&type=template&id=62c80761&scoped=true&"
import script from "./EditCardDetailsFormNew.vue?vue&type=script&lang=js&"
export * from "./EditCardDetailsFormNew.vue?vue&type=script&lang=js&"
import style0 from "./EditCardDetailsFormNew.vue?vue&type=style&index=0&id=62c80761&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c80761",
  null
  
)

export default component.exports